module.exports = __webpack_public_path__ + "images/banner-5e1a62479036fad8147b01e32e5ee526.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/head-banner/images/banner.png
// module id = 412
// module chunks = 3